/* eslint-disable security/detect-object-injection */
import React, { useState, useRef } from 'react';

const MobileCarousel = ({ items, type, navigate }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

    const handleTouchStart = (e) => {
        touchStartX.current = e.targetTouches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.targetTouches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (!touchStartX.current || !touchEndX.current) return;
    
        const distance = touchStartX.current - touchEndX.current;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;

        if (isLeftSwipe && currentIndex < items.length - 1) {
            setCurrentIndex(prev => prev + 1);
        }
        if (isRightSwipe && currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
        }
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const currentItem = items[currentIndex];

    return (
        <div className="w-full mx-auto">
            {/* Main Content Area */}
            <div className="px-6 py-8">
                {/* Template Preview */}
                <div 
                    className="relative mb-6"
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <div className="aspect-[3/4] overflow-hidden">
                        <img
                            src={currentItem.img_url}
                            alt={currentItem.name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                <div className="mt-[-50px]">
                    <p className="text-center sm:text-[22px] text-[20px] text-[#343434] font-medium">
                        {currentItem.name}</p>
                    <p className="text-center sm:text-[16px] text-[15px] text-[#343434] 
                                            font-medium mx-2 mt-2">{currentItem.description}</p>
                    <div className={`mt-3 flex flex-col items-center`}>
                        <button className="border border-[#A1A1A9] rounded-md text-[14px] text-[#52525A] 
                            px-[31px] py-[5px] w-[233px]">
                            Preview</button>
                        <button type='button' onClick={() => navigate(`/auctions/${type}/create/${currentItem.routeName}`)}>
                            <p className="bg-[#282828] rounded-md text-[14px] text-white mt-2.5 font-medium 
                                px-[20px] py-[7px] w-[233px]">
                                Continue with this template
                            </p>
                        </button>
                    </div>
                </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center gap-2 mb-6">
                {items.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`w-2 h-2 rounded-full transition-all duration-200 ${
                            index === currentIndex
                                ? 'bg-gray-800 w-6'
                                : 'bg-gray-300 hover:bg-gray-400'
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default MobileCarousel;